import React from 'react';

const Tooltip = ({ text, content, align = 'center', children }) => {
    if (!text && !content) return children;

    const isLeft = align === 'left';

    return (
        <div className="custom-tooltip-wrapper" style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <style>{`
                .custom-tooltip-wrapper .custom-tooltip-text {
                    visibility: hidden;
                    width: max-content;
                    max-width: 260px;
                    background-color: #1A110B;
                    color: #fff;
                    text-align: left;
                    border-radius: 12px;
                    padding: 12px 16px;
                    position: absolute;
                    z-index: 10000;
                    top: 130%;
                    left: ${isLeft ? '0' : '50%'};
                    transform: ${isLeft ? 'none' : 'translateX(-50%)'};
                    opacity: 0;
                    transition: opacity 0.2s;
                    font-size: 0.8rem;
                    font-weight: 500;
                    line-height: 1.4;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.25);
                    pointer-events: none;
                    white-space: normal;
                    text-transform: none;
                    letter-spacing: normal;
                }
                .custom-tooltip-wrapper .custom-tooltip-text::after {
                    content: "";
                    position: absolute;
                    bottom: 100%;
                    left: ${isLeft ? '15px' : '50%'};
                    margin-left: -5px;
                    border-width: 5px;
                    border-style: solid;
                    border-color: transparent transparent #1A110B transparent;
                }
                .custom-tooltip-wrapper:hover .custom-tooltip-text {
                    visibility: visible;
                    opacity: 1;
                }
            `}</style>
            {children}
            <div className="custom-tooltip-text">
                {content || text}
            </div>
        </div>
    );
};

export default Tooltip;
